module.exports = transaction

function transaction (func) {
    var obs = this
    var rawList = obs._list.slice()

    if (func(rawList) !== false){ // allow cancel
        return obs.set(rawList)
    }

}


//////////////////
// WEBPACK FOOTER
// ./~/observ-array/transaction.js
// module id = 150
// module chunks = 0